import { DispatchToExport } from "../../../../../core";

export const formatDispatchInCustomerDispatch = {
  exportFile: "despacho_clientes.xlsx",
  columns: [
    {
      title: "Fecha original de entrega",
      name: "originalDeliveryDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) =>
        element.originalDeliveryDate
          ? element.originalDeliveryDate
          : element.deliveryDate,
    },
    {
      title: "Fecha de entrega",
      name: "deliveryDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.deliveryDate,
    },
    {
      title: "Fecha de venta",
      name: "saleDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.saleDate,
    },
    {
      title: "Fecha de pago",
      name: "paymentDate",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.paymentDate,
    },
    {
      title: "Empresa",
      name: "companyCode",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.companyCode,
    },
    {
      title: "N° de NV",
      name: "saleNoteId",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.saleNoteId,
    },
    {
      title: "N° de despacho",
      name: "dispatchId",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.dispatchId,
    },
    {
      title: "VTEX",
      name: "vtexCode",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.vtexCode,
    },
    {
      title: "Modalidad de despacho",
      name: "deliveryTypeName",
      type: "string",
      editable: false,
      checkAll: false,
      align: "left",
      class: "confirmationDispatches",
      value: (element: DispatchToExport) => element.deliveryTypeName,
    },
    {
      title: "Tipo de despacho",
      name: "dispatchTypeName",
      type: "string",
      editable: false,
      checkAll: false,
      align: "left",
      class: "confirmationDispatches",
      value: (element: DispatchToExport) => element.dispatchTypeName,
    },
    {
      title: "Entidad Actual",
      name: "currentEntityName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.currentEntityName,
    },
    {
      title: "Entidad de Venta",
      name: "saleLocationName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.saleLocationName,
    },
    {
      title: "Entidad destino",
      name: "nextEntityName",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.nextEntityName,
    },
    {
      title: "Dirección de Entrega",
      name: "deliveryAddress",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) =>
        element.nextEntityName
          ? element.nextEntityAddress ? element.nextEntityAddress : element.deliveryAddress
          : element.deliveryAddress
          ? element.deliveryAddress.split("$%$").join(" ")
          : "",
    },
    {
      title: "Distrito",
      name: "dispatchDistrict",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.dispatchDistrict,
    },
    {
      title: "Zona de despacho",
      name: "dispatchZone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchToExport) => element.dispatchZone,
    },
    {
      title: "Referencia",
      name: "reference",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchToExport) => element.reference,
    },
    {
      title: "Documento de Cliente",
      name: "customerDocumentNumber",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.customerDocumentNumber,
    },
    {
      title: "Nombre de Cliente",
      name: "customer",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.customer,
    },
    {
      title: "Email del Cliente",
      name: "mailCustomer",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.mailCustomer,
    },
    {
      title: "Teléfono de Cliente",
      name: "telephone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.telephone,
    },
    {
      title: "Documento persona que retira",
      name: "telephone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.withdrawPersonDoc,
    },
    {
      title: "Persona que retira",
      name: "telephone",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.withdrawPerson,
    },
    {
      title: "Inicio ventana horaria",
      name: "startDateDeliveryWindow",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.startDateDeliveryWindow,
    },
    {
      title: "Fin ventana horaria",
      name: "endDateDeliveryWindow",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.endDateDeliveryWindow,
    },
    /*     {
      title: "Listado de jaba/LPNs",
      name: "lpns",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.lpns,
    }, */
    {
      title: "Cantidad de jabas/LPN",
      name: "countLpns",
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.countLpns,
    },
    {
      title: 'Agrupación de entidad origen',
      name: 'originEntityGroupName',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.originEntityGroupName
    },
    {
      title: 'Agrupación de entidad actual',
      name: 'groupName',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.groupName
    },
    {
      title: 'Agrupación de entidad siguiente',
      name: 'nextEntityGroupName',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.nextEntityGroupName
    },
    {
      title: 'Agrupación de entidad final',
      name: 'finalEntityGroupName',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.finalEntityGroupName
    },
    {
      title: 'Latitud',
      name: 'latitud',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.geoLocalization != null ? element.geoLocalization.split(",")[0] : ''
    },
    {
      title: 'Longitud',
      name: 'longitud',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.geoLocalization != null ? element.geoLocalization.split(",")[1] : ''
    },
    {
      title: 'Entidad final',
      name: 'finalEntityCode',
      sort: true,
      type: "string",
      editable: false,
      checkAll: false,
      class: "left",
      value: (element: DispatchToExport) => element.finalEntityCode
    },
    {
      title: 'Monto total de venta',
      name: 'totalSaleAmount',
      sort: true,
      type: "number",
      editable: false,
      checkAll: false,
      class: "center",
      value: (element: DispatchToExport) => element.totalSaleAmount != null ? element.totalSaleAmount : 0
    }
  ],
};
